import React, { useState, useRef } from 'react';
import { Box, Typography, Grid, MenuItem } from '@mui/material';
import { UtilityButton } from 'lib/components/Buttons/buttons';
import { CustomDialog } from 'lib';
import useWindowDimensions from 'hooks/useWindowDimensions';

import { TextField, Select } from 'lib';

import { useTranslation } from 'react-i18next';
import { Formik, Form, Field } from 'formik';
import * as yup from 'yup';

import styles from 'styles/inputStyles.module.scss';
import stylesVehicles from './VehicleStyling.module.scss';
import { VehiclesAPI } from 'api_darex';
import { toast } from 'react-toastify';
import DeleteIcon from '@mui/icons-material/Delete';
import ConfirmModal from 'lib/components/Modals/ConfirmModal';
import AddIcon from '@mui/icons-material/Add';

const Step3EngineForm = ({
    newModel,
    setNewModel,
    brand,
    rowId,
    setRowId,
    setActiveStep,
    formRefChooseEngine,
    initialStateEngines,
    validationStateEngines,
    engines,
    getAllEngines,
    updateData,
}) => {
    const { vw } = useWindowDimensions();
    const { t } = useTranslation();
    const [openConfirm, setOpenConfirm] = useState(false);
    const [addEngine, setAddEngine] = useState(false);
    const formRefEngines = useRef();

    const handleSubmitEngines = () => {
        if (formRefEngines.current) {
            formRefEngines.current.handleSubmit();
        }
    };

    const INITIAL_FORM_STATE3 = {
        engineName: '',
        engineType: '',
    };

    const FORM_VALIDATION3 = yup.object().shape({
        // Cheile trebuie sa aiba aceasi denumire ca in INITIAL_FORM_STATE
        engineName: yup
            .string() // Tipul valorii
            .typeError(t('This name is not a valid one!'))
            .trim()
            .min(3, t('The name has to contain at least three characters'))
            .required(t('Engine name is mandatory')),
        engineType: yup
            .string() // Tipul valorii
            .typeError(t('This name is not a valid one!'))
            .trim()
            .min(3, t('The name has to contain at least three characters'))
            .required(t('Engine type is mandatory')),
    });

    return (
        <Box sx={{ padding: '0 0rem 0 0.5rem' }}>
            <div
                style={{
                    marginTop: '32px',
                    marginBottom: '22px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: vw < 600 ? '1rem' : '0rem',
                }}
            >
                <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                    <Typography variant="addingVehicleModel"> {t('Engines')} </Typography>
                </div>

                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <UtilityButton onClick={() => setAddEngine(true)} startIcon={<AddIcon />} type="button">
                        {t('Add new engine type')}
                    </UtilityButton>
                </div>
            </div>
            <Box>
                <Formik
                    innerRef={formRefChooseEngine}
                    initialValues={{
                        ...initialStateEngines,
                    }}
                    validationSchema={validationStateEngines}
                    onSubmit={(values) => {
                        setNewModel({
                            ...newModel,
                            engines: values.engines,
                        });

                        'id' in updateData
                            ? VehiclesAPI.editModel(updateData.id, {
                                  name: newModel.modelName,
                                  type: newModel.modelType,
                                  brandId: brand,
                                  modelEngine: values.engines.map((engine) => ({ engineId: engine })),
                                  modelColor: newModel.colors.map((color) => ({ colorId: color })),
                              }).then((res) => {
                                  if (res.ok === true) {
                                      setActiveStep((prevActiveStep) => prevActiveStep + 1);
                                      toast.success(t('The model was succesfully updated'));
                                  } else {
                                      toast.error(t('An error has occured. Please try again'));
                                  }
                              })
                            : VehiclesAPI.createModel({
                                  name: newModel.modelName,
                                  type: newModel.modelType,
                                  brandId: brand,
                                  modelEngine: values.engines.map((engine) => ({ engineId: engine })),
                                  modelColor: newModel.colors.map((color) => ({ colorId: color })),
                              }).then((res) => {
                                  if (res.ok === true) {
                                      setActiveStep((prevActiveStep) => prevActiveStep + 1);
                                      toast.success(t('The model was succesfully created'));
                                  } else {
                                      toast.error(t(res.error.response.data.message));
                                  }
                              });
                    }}
                >
                    {(props) => (
                        <Form>
                            <Grid container justifyContent={'space-around'}>
                                <Grid item xs={12}>
                                    <Box>
                                        <div
                                            role="group"
                                            aria-labelledby="checkbox-group"
                                            className={styles.checkboxGroupWrapper}
                                        >
                                            <div className={styles.checkboxGroup} style={{ flexDirection: 'column' }}>
                                                {engines?.map((engine) => (
                                                    <div key={engine.id} className={stylesVehicles.hoverGroupV}>
                                                        <label key={engine.id}>
                                                            <Field type="checkbox" name="engines" value={engine.id} />
                                                            {engine.name}
                                                            <li> {t(engine.type)}</li>
                                                        </label>

                                                        {props.values.engines.findIndex((c) => c === engine.id) < 0 && (
                                                            <div className={stylesVehicles.buttonForDelete}>
                                                                <DeleteIcon
                                                                    sx={{ cursor: 'pointer', position: 'absolute' }}
                                                                    color={'error'}
                                                                    onClick={() => {
                                                                        setRowId(engine.id);
                                                                        setOpenConfirm(true);
                                                                    }}
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                            {props.errors.engines ? (
                                                <div className={styles.checkboxGroupError}>{props.errors.engines}</div>
                                            ) : (
                                                ''
                                            )}
                                        </div>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Form>
                    )}
                </Formik>
                <CustomDialog
                    buttonClose={t('Cancel')}
                    buttonFinish={t('Finish')}
                    width="600px"
                    open={addEngine}
                    setOpen={setAddEngine}
                    title={t('Add new engine type')}
                    onClickButtonFinish={handleSubmitEngines}
                >
                    <Formik
                        innerRef={formRefEngines}
                        initialValues={{
                            ...INITIAL_FORM_STATE3,
                        }}
                        validationSchema={FORM_VALIDATION3}
                        onSubmit={(values) => {
                            VehiclesAPI.createEngine({
                                name: values.engineName,
                                type: values.engineType,
                                brandId: brand,
                            }).then((res) => {
                                if (res.ok === true) {
                                    getAllEngines();
                                    setAddEngine(false);
                                    toast.success(t('Engine added succesfully'));
                                } else {
                                    toast.error(t(res.error.response.data.message));
                                }
                            });
                        }}
                    >
                        <Form>
                            <Grid container justifyContent={'space-between'} spacing={2}>
                                <Grid item xs={12}>
                                    <TextField name="engineName" label={t('Engine name')} />
                                </Grid>
                                <Grid item xs={12}>
                                    <Select name="engineType" label={t('Engine type')}>
                                        {[
                                            { id: 1, name: 'thermic', realName: t('Thermic') },
                                            { id: 2, name: 'electrical', realName: t('Electric') },
                                            { id: 3, name: 'hibrid', realName: t('Hybrid') },
                                        ].map((option, pos) => (
                                            <MenuItem key={pos} value={option.name}>
                                                {option.realName}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </Grid>
                            </Grid>
                        </Form>
                    </Formik>
                </CustomDialog>

                <ConfirmModal
                    open={openConfirm}
                    setOpen={setOpenConfirm}
                    text={t('Are you sure you want to delete this engine?')}
                    onClickButtonYes={() =>
                        VehiclesAPI.deleteEngine(rowId).then((res) => {
                            if (res.ok === true) {
                                toast.success(t('Engine deleted succesfully'));
                                getAllEngines();
                                setOpenConfirm(false);
                            }
                        })
                    }
                />
            </Box>
        </Box>
    );
};

export default Step3EngineForm;
